import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TranslateService } from '@ngx-translate/core';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { GoogleMapsLoaderService } from './shared/services/maps/google-maps-loader.service';
import { environment } from '../environments/environment';
import { faviconUrl } from './shared/services/client-config';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = environment.appTitle;

  private document = inject(DOCUMENT);

  constructor(
    private primengConfig: PrimeNGConfig,
    private translate: TranslateService,
    private googleMapsLoader: GoogleMapsLoaderService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle(environment.appTitle);
    const link: HTMLLinkElement =
      this.document.querySelector("link[rel='icon']") ??
      this.document.createElement('link');
    link.setAttribute('rel', 'icon');
    link.setAttribute('type', 'image/x-icon');
    link.setAttribute('href', faviconUrl());
    this.document.head.appendChild(link);
    this.googleMapsLoader.loadGoogleMaps().catch((error) => {
      console.error('Error loading Google Maps:', error);
    });
    this.primengConfig.ripple = false;
    this.translate.stream(['primeng']).subscribe((translations: any) => {
      this.primengConfig.setTranslation(translations['primeng']);
    });
    AOS.init();
  }
}
